import { render } from "./PlanesPa.vue?vue&type=template&id=54cdca81&scoped=true"
import script from "./PlanesPa.vue?vue&type=script&lang=js"
export * from "./PlanesPa.vue?vue&type=script&lang=js"

import "./PlanesPa.vue?vue&type=style&index=0&id=54cdca81&lang=scss&scoped=true"

import exportComponent from "C:\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cdca81"]])

export default __exports__